import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import apiCall from '../../services/apiCall';

export interface GetFileAttachmentUploadLinkFromMyAccountCommandPayload {
  fileId?: string;
  claimId?: string;
  additionalInformationId?: string;
}

export interface GetFileAttachmentUploadLinkFromMyAccountCommandResponse {
  uploadQrCode: string;
  uploadUrl: string;
}

const ENDPOINT = `${APIConfiguration.workflow}files/myaccount-attachments/uploadLink`;

export const getFileAttachmentUploadLinkFromMyAccountCommand = async ({
  fileId,
  claimId,
  additionalInformationId,
}: GetFileAttachmentUploadLinkFromMyAccountCommandPayload): Promise<
  | BackResponse<GetFileAttachmentUploadLinkFromMyAccountCommandResponse>
  | BackResponseFailure
> => {
  try {
    return await apiCall<
      BackResponse<GetFileAttachmentUploadLinkFromMyAccountCommandResponse>
    >(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        additionalInformationId,
        claimId,
        fileId,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
